import { render, staticRenderFns } from "./migas.vue?vue&type=template&id=a60fc548&scoped=true&lang=pug"
import script from "./migas.vue?vue&type=script&lang=js"
export * from "./migas.vue?vue&type=script&lang=js"
import style0 from "./migas.vue?vue&type=style&index=0&id=a60fc548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60fc548",
  null
  
)

export default component.exports